import { isEmail, isRequired } from 'evcharging/app/validation/validators';
import { CALCULATOR_RESULT_ENDPOINT } from 'evcharging/app/server/endpoints';
import { httpClient } from 'evcharging/app/client/index';

const validators = {
  email: [isRequired, isEmail],
};

const sendCalculatorResult = (payload: Record<string, string | number>) =>
  httpClient().setBody(payload).setValidators(validators).post(CALCULATOR_RESULT_ENDPOINT);

export default sendCalculatorResult;
